module.exports = __webpack_public_path__ + "static/skilled_technical-d171b15419fff992bfed5e941be847ff.jpg";